import { render, staticRenderFns } from "./MarketPage.vue?vue&type=template&id=aab63fba&scoped=true&"
import script from "./MarketPage.vue?vue&type=script&lang=js&"
export * from "./MarketPage.vue?vue&type=script&lang=js&"
import style0 from "./MarketPage.vue?vue&type=style&index=0&id=aab63fba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab63fba",
  null
  
)

export default component.exports